import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import PropTypes from "prop-types";

function TabPanel(props) {
  const { children, key, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      className={className}
      hidden={value !== index}
      id={`${key}panel-${index}`}
      aria-labelledby={`{key}-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  className: PropTypes.string,
  tabKey: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.node,
};

TabPanel.defaultProps = {
  className: "",
  children: null,
};

export default TabPanel;
